angular.module("imagenet")
    .controller('LoginCtrl', ['UserFactory','$http','$cookies','$rootScope', function (UserFactory, $http, $cookies, $rootScope) {
        'use strict';
        var vm = this;
        vm.login = login;
        vm.logout = logout;
        vm.setpassword = setpassword;
        vm.forgotpassword = forgotpassword;

        function login(username, password) {
            UserFactory.login(username, password).then(function success(response) {
                $cookies.put("loggedIn", 1);
            }, handleError);
        }

        function setpassword(ver, pass, pass2){
            if (pass===pass2 && (pass !== '' || pass !== null)) {
                UserFactory.setpassword(ver, pass).then(function success(response) {
                    $cookies.put("loggedIn", 1);
                    window.location = "/";
                }, handleError);
            }
            else {
                vm.errored = true;
            }
        }

        function forgotpassword(mail) {
            UserFactory.forgotPassword(mail).then(function (response) {
                vm.forgotSuccess = true;
            }, handleError);
        }

        function logout() {
            UserFactory.logout();
        }

        function handleError(response) {
            vm.errored = null;
            vm.errored = true;
        }
    }]);